import React, { PureComponent } from 'react';
import * as topojson from 'topojson-client';
import { GeoJSON, withLeaflet } from 'react-leaflet';

function mergeTopojsonByKey(topoJsonData, propertyKey) {
  const key = Object.keys(topoJsonData.objects)[0];
  const topoJsonObject = topoJsonData.objects[key];
  const groups = topoJsonObject.geometries
    .reduce((res, item) => {
      const currentValue = item.properties[propertyKey];

      if (!res.includes(currentValue)) {
        res.push(currentValue);
      }

      return res;
    }, [])
    .map(value =>
      topojson.merge(
        topoJsonData,
        topoJsonObject.geometries.filter(d => d.properties[propertyKey] === value)
      )
    );

  // const groupedTopojson = {
  //   ...topoJsonData,
  //   objects: {
  //     geo: groups
  //   }
  // };

  return groups;
}

class Overlay extends PureComponent {

  render() {
    if (!this.props.geojsonData) {
      return null;
    }

    return (
      <GeoJSON
        data={this.props.geojsonData}
        fill={false}
        weight={this.props.weigh || 1}
        color={this.props.color || '#aaa'}
        opacity={this.props.opacity || 1}
        smoothFactor={0.5}
        className="overlay-layer"
      />
    );
  }
}

export default withLeaflet(Overlay);
